import React from "react";
import { Container } from "react-bootstrap";
import "./PropertiesTab.css";

export default function PropertiesTab({ productsdetailss }) {
  return (
    <Container className="properties_tab_section">
      <p>
        {/* Spirulina is a natural blue-green algae considered one of the most
        nutrient-dense superfoods. It is rich in plant protein, vitamins,
        minerals, antioxidants, and essential amino acids. Spirulina helps
        support energy levels, immunity, and overall daily nutrition. It is easy
        to digest and suitable for regular wellness use. Commonly available as
        tablets or powder, spirulina is used worldwide as a natural health
        supplement. */}
        {productsdetailss}
      </p>
    </Container>
  );
}
